import React, { useEffect } from "react";
import logo from "../../assets/logo2.png";
import "../../styles/auth-enterprise.css";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  useEffect(() => {
    document.body.classList.add("tx-auth-body-scroll");
    return () => {
      document.body.classList.remove("tx-auth-body-scroll");
    };
  }, []);

  return (
    <div className="tx-auth-container">
      {/* Left Brand Panel */}
      <aside className="tx-auth-brand-panel" aria-label="Product Highlights">
        <div className="tx-auth-brand-content">
          <header className="tx-auth-brand-header">
            <img
              src={logo}
              alt="Threatactix"
              className="tx-auth-brand-logo"
            />
            <span className="tx-auth-brand-badge">
              AI-Integrated Darknet Monitoring
            </span>
          </header>

          <h1 className="tx-auth-brand-headline">
            Detect Hidden <span className="accent-threats">threats</span>. Understand Risk.{" "}
            <span className="accent-act">Act</span> before impact<span className="accent-dot">.</span>
          </h1>

          <div className="tx-auth-feature-list" role="list">
            <div className="tx-auth-feature-item" role="listitem">
              <span className="tx-auth-feature-icon" aria-hidden="true">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              <span>Darknet and ransomware intelligence</span>
            </div>

            <div className="tx-auth-feature-item" role="listitem">
              <span className="tx-auth-feature-icon" aria-hidden="true">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              <span>Threat actor and campaign monitoring</span>
            </div>

            <div className="tx-auth-feature-item" role="listitem">
              <span className="tx-auth-feature-icon" aria-hidden="true">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              <span>AI-assisted threat analysis</span>
            </div>

            <div className="tx-auth-feature-item" role="listitem">
              <span className="tx-auth-feature-icon" aria-hidden="true">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              <span>Sector-based threat intelligence</span>
            </div>
          </div>
        </div>

        <footer className="tx-auth-brand-footer">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <span>Powered by <span className="footer-tagline">Threatactix Cyber Intelligence</span></span>
        </footer>
      </aside>

      {/* Right Auth Form Panel */}
      <main className="tx-auth-form-panel">
        <div className="tx-auth-form-card">
          {children}
        </div>
      </main>
    </div>
  );
}
